module.exports = __webpack_public_path__ + "img/2_1-parcheggio-1-bus.611622d8.png";